const GET_ALL_CHECK_CASHIER = "GET_ALL_CHECK_CASHIER";
const GET_ALL_WITH_DATE_END_CASHIER = "GET_ALL_WITH_DATE_END_CASHIER"


module.exports = {
  GET_ALL_CHECK_CASHIER,
  GET_ALL_WITH_DATE_END_CASHIER
};
